import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';

const NAV_LINKS = [
    { label: 'Home',     id: 'home' },
    { label: 'About',    id: 'about' },
    { label: 'Services', id: 'services' },
    { label: 'Why Us',   id: 'whyus' },
    { label: 'Contact',  id: 'contact' },
];

const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
};

const Navbar = () => {
    const [scrolled, setScrolled]   = useState(false);
    const [menuOpen, setMenuOpen]   = useState(false);
    const [active,   setActive]     = useState('home');

    useEffect(() => {
        const onScroll = () => {
            setScrolled(window.scrollY > 50);

            // Highlight active section
            const sections = NAV_LINKS.map(l => document.getElementById(l.id));
            let current = 'home';
            sections.forEach(sec => {
                if (sec && window.scrollY >= sec.offsetTop - 120) current = sec.id;
            });
            setActive(current);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const handleNav = (id) => {
        scrollTo(id);
        setMenuOpen(false);
    };

    return (
        <>
            {/* Mobile overlay */}
            <div className={`overlay ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(false)} />

            <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
                <div className="nav-brand" onClick={() => handleNav('home')}>
                    <span className="brand-connect">CONNECT</span>
                    <span className="brand-rest"> ALL (SL)</span>
                </div>

                <div className={`nav-links ${menuOpen ? 'open' : ''}`}>
                    {NAV_LINKS.map(({ label, id }) => (
                        <span
                            key={id}
                            className={`nav-link ${active === id ? 'active' : ''}`}
                            onClick={() => handleNav(id)}
                        >
                            {label}
                        </span>
                    ))}
                    <span className="nav-cta" onClick={() => handleNav('contact')}>
                        Get A Quote
                    </span>
                </div>

                <button
                    className="hamburger"
                    onClick={() => setMenuOpen(prev => !prev)}
                    aria-label="Toggle menu"
                >
                    {menuOpen ? <FaTimes /> : <FaBars />}
                </button>
            </nav>
        </>
    );
};

export default Navbar;
